import React, { useEffect } from 'react';
import Navbar from './portflio/navbar';
import Hero from './portflio/components/Hero';
import About from './portflio/components/About';
import Projects from './portflio/components/Projects';
import Avis from './portflio/components/Avis';
import Contact from './portflio/components/Contact';
import Footer from './portflio/components/Footer';
import './App.css';

function App() {
  
  useEffect(() => {
    // Ajouter le CSS pour le scroll smooth
    const style = document.createElement('style');
    style.textContent = `
      html {
        scroll-behavior: smooth;
      }
      
      /* Animation personnalisée pour les ancres */
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      .scroll-target {
        animation: fadeInUp 0.6s ease-out;
      }
    `;
    document.head.appendChild(style);

    // Gestionnaire pour le scroll vers les ancres
    const handleAnchorClick = (e) => {
      const href = e.currentTarget.getAttribute('href');
      
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          const offset = 80; // Compensation pour la navbar fixe
          const targetPosition = targetElement.offsetTop - offset;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

          // Ajouter une classe d'animation à la cible
          targetElement.classList.add('scroll-target');
          setTimeout(() => {
            targetElement.classList.remove('scroll-target');
          }, 600);
        }
      }
    };

    // Ajouter les écouteurs d'événements à tous les liens d'ancrage
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(link => {
      link.addEventListener('click', handleAnchorClick);
    });

    return () => {
      // Nettoyage
      anchorLinks.forEach(link => {
        link.removeEventListener('click', handleAnchorClick);
      });
      document.head.removeChild(style);
    };
  }, []);

  // Fonction pour gérer la navigation
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.offsetTop - offset;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="App">
      <Navbar scrollToSection={scrollToSection} />
      <div className="min-h-screen w-full bg-[#0f172a] relative">
        {/* Dark Basic Grid Background - Faded */}
        <Hero />
        <About />
        <Projects />
        <Avis />
        <Contact />
        
        <div
          className="absolute inset-0 z-0"
          style={{
            background: "#0f172a",
            backgroundImage: `
              linear-gradient(to right, rgba(148,163,184,0.2) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(148,163,184,0.2) 1px, transparent 1px)
            `,
            backgroundSize: "40px 40px",
          }}
        />
      </div>
      <Footer />
    </div>
  );
}

export default App;